import {elementNameConst, shapeTypeConst} from '../../../conf';

/**
 * 拓扑插件-自定义单弧度曲线断线重连动画-扩展
 */
export default {
  name: shapeTypeConst.quadraticGrowthRunning,
  type: elementNameConst.edge,
  options: {
    /**
     * 绘制后的附加操作，默认没有任何操作
     * @param cfg 边的配置项
     * @param group 图形分组，边中的图形对象的容器
     */
    afterDraw(cfg, group) {

      // 获得组中的第一个形状，这是边的路径=
      const shape = group.getFirst();
      const length = shape.getTotalLength();

      // 动画配置
      const animateCfg = {
        // 是否重复执行动画
        repeat: true,
        // 执行一次的持续时间
        duration: 2000
      };

      // 红色圆圈的动画
      shape.animate((ratio) => {
        // 每个帧中的操作。比率范围从0到1，表示动画的进度。返回修改后的配置
        const startLen = ratio * length;
        // 计算lineDash
        return {
          lineDash: [startLen, length - startLen]
        };
      }, animateCfg);
    }
  },
  // 继承节点名
  extendedNodeName: shapeTypeConst.quadratic
};
